import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

const DocumentoRelacionado = ({ documentoRelacionado }) => {
    return (
        <>
            {/* DISEÑO PARA DESKTOP/TABLET (lg y superiores - 992px+) */}
            <div className="d-none d-lg-block">
                <Card className="mb-3 border">
                    <Card.Header className="bg-light py-2">
                        <strong>Documento Relacionado</strong>
                    </Card.Header>
                    <Card.Body className="py-2">
                        <Row>
                            <Col xs={6}>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Id del Documento Relacionado:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>{documentoRelacionado?.idDocumentoRelacionado}</small>
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Serie:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>{documentoRelacionado?.serie}</small>
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Folio:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>{documentoRelacionado?.folio}</small>
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Núm. parcialidad:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>{documentoRelacionado?.numParcialidad}</small>
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Moneda Documento Relacionado:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>{documentoRelacionado?.monedaDocumentoRelacionado}</small>
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Equivalencia DR:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>{documentoRelacionado?.equivalenciaDR || '1'}</small>
                                    </Col>
                                </Row>
                            </Col>

                            <Col xs={6}>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Objeto Impuesto DR:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>{documentoRelacionado?.objetoImpDR}</small>
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Importe Saldo Anterior:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>${documentoRelacionado?.importeSaldoAnterior}</small>
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Importe Pagado:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>${documentoRelacionado?.importePagado}</small>
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Importe Saldo Insoluto:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>${documentoRelacionado?.importeSaldoInsoluto}</small>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </div>

            {/* DISEÑO PARA MÓVIL (menor a 992px) */}
            <div className="d-block d-lg-none">
                <Card className="mb-2 border">
                    <Card.Header className="bg-light py-1">
                        <strong style={{ fontSize: "0.75rem" }}>Documento Relacionado</strong>
                    </Card.Header>
                    <Card.Body className="p-2">
                        <div style={{ fontSize: "0.65rem", lineHeight: "1.3" }}>
                            <div className="mb-2">
                                <div className="text-muted" style={{ fontSize: "0.6rem" }}>
                                    ID: {documentoRelacionado?.idDocumentoRelacionado}
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Serie:</span>
                                    <span>{documentoRelacionado?.serie}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Folio:</span>
                                    <span>{documentoRelacionado?.folio}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Núm. parcialidad:</span>
                                    <span>{documentoRelacionado?.numParcialidad}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Moneda:</span>
                                    <span>{documentoRelacionado?.monedaDocumentoRelacionado}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Equivalencia DR:</span>
                                    <span>{documentoRelacionado?.equivalenciaDR || '1'}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Objeto Impuesto DR:</span>
                                    <span>{documentoRelacionado?.objetoImpDR}</span>
                                </div>
                            </div>

                            <div className="border-top pt-1">
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Saldo Anterior:</span>
                                    <span>${documentoRelacionado?.importeSaldoAnterior}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Importe Pagado:</span>
                                    <span className="fw-bold text-success">${documentoRelacionado?.importePagado}</span>
                                </div>
                                <div className="d-flex justify-content-between bg-light px-1 mt-1">
                                    <span className="fw-bold">Saldo Insoluto:</span>
                                    <span className="fw-bold text-danger">${documentoRelacionado?.importeSaldoInsoluto}</span>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </>
    );
};

DocumentoRelacionado.propTypes = {
    documentoRelacionado: PropTypes.shape({
        idDocumentoRelacionado: PropTypes.string,
        serie: PropTypes.string,
        folio: PropTypes.string,
        numParcialidad: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        monedaDocumentoRelacionado: PropTypes.string,
        equivalenciaDR: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        objetoImpDR: PropTypes.string,
        importeSaldoAnterior: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        importePagado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        importeSaldoInsoluto: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
};

export default DocumentoRelacionado;
